import $ from 'jquery';
import log from 'log';
import style from 'style';
import state from 'state';

var $window = $(window);

export default function DoodleCanvas() {
    var me = this,
        div = $('#doodleOverlay'),
        cont = $('#map'),
        canvas = document.getElementById('doodleCanvas'),
        butOK = $('#doodleOK'),
        butRedo = $('#doodleRedo'),
        butCancel = $('#doodleCancel'),
        ctx = null,
        origin, down, last, strokes, stroke, offset;

    me.clear = function () {
        log('clear');
        down = false;
        last = [];
        strokes = [];
        stroke = null;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    };

    function resize() {
        log('resize');
        var page0 = state.info.pagesize[state.page],
            page1 = state.map.latLngToContainerPoint([0, 0]),
            page2 = state.map.latLngToContainerPoint([page0.h, page0.w]),
            force = function (value, min, max) { return (value < min) ? min : (value > max) ? max : value; },
            contW = cont.width(),
            contH = cont.height();
        //TODO: resize from page
        // we do not resize the tablet applet, as it leads to problems with Java plugin
        me.clear();
        origin = page1; //{ x: page1.x, y: page1.y }; // they later change
        offset = cont.offset();
        page1.x = force(page1.x, 0, contW);
        page1.y = force(page1.y, 0, contH);
        page2.x = force(page2.x, 0, contW);
        page2.y = force(page2.y, 0, contH);
        canvas.width = page2.x - page1.x;
        canvas.height = page2.y - page1.y;
        $(canvas).css({
            left:   page1.x + 'px',
            top:    page1.y + 'px',
            width:  (page2.x - page1.x) + 'px',
            height: (page2.y - page1.y) + 'px'
        });
        //TODO
    }

    function browserInput() {
        div.show();
        resize();
        $window.on('resize', resize);
        listenEvents();
    }

    me.get = function (callback) { //TODO togliere primo parametro
        log('doodle get');
        me.callback = callback;
        browserInput();
    };

    function getCoords(e) {
        if (e.targetTouches) e = e.targetTouches[0];
        return {
            x: e.pageX - offset.left - origin.x,
            y: e.pageY - offset.top - origin.y
        };
    }

    function convertCoords(e) {
        if (e.targetTouches) e = e.targetTouches[0];
        var ll = state.map.containerPointToLatLng([
            e.pageX - offset.left,
            e.pageY - offset.top
        ]);
        return [ ll.lng, ll.lat ];
    }

    function pointerDown(evt) {
        if (evt.preventDefault) evt.preventDefault();
        if (evt.type.charAt(0) == 't') {
            // after a touch event we want mouse events no more
            canvas.onmousedown = canvas.onmouseup = canvas.onmousemove = canvas.onmouseout = null;
        }
        var c = getCoords(evt);
        if (c.x < 0 || c.y < 0 || c.x > canvas.width || c.y > canvas.height)
            return false;
        down = true;
        stroke = [convertCoords(evt)];
        ctx.strokeStyle = style.doodle.color;
        ctx.lineWidth = style.doodle.weight;
        ctx.lineCap = 'round';
        ctx.fillRect(c.x - ctx.lineWidth / 2, c.y - ctx.lineWidth / 2, ctx.lineWidth, ctx.lineWidth);
        last = c;
        return false;
    }

    function pointerMove(evt) {
        if (evt.preventDefault) evt.preventDefault();
        if (down) {
            var c = getCoords(evt);
            stroke.push(convertCoords(evt));
            ctx.beginPath();
            ctx.moveTo(last.x, last.y);
            ctx.lineTo(c.x, c.y);
            ctx.stroke();
            last = c;
        }
        return false;
    }

    function pointerUp(evt) {
        if (down) {
            try { pointerMove(evt); } catch (e) { /* seems that touchend doesn't send any point */ }
            down = false;
            strokes.push(stroke);
        }
        return false;
    }

    function listenEvents() {
        if ('ontouchstart' in document.documentElement) {
            canvas.ontouchstart = pointerDown;
            canvas.ontouchend = pointerUp;
            canvas.ontouchmove = pointerMove;
            canvas.ontouchleave = pointerUp;
        }
        canvas.onmousedown = pointerDown;
        canvas.onmouseup = pointerUp;
        canvas.onmousemove = pointerMove;
        canvas.onmouseout = pointerUp;
    }

    function ignoreEvents() {
        if ('ontouchstart' in document.documentElement) {
            canvas.ontouchstart = null;
            canvas.ontouchend = null;
            canvas.ontouchmove = null;
            canvas.ontouchleave = null;
            // we also listen to mouse events, as touch could be supported but not in use
            // we will remove mouse listening on first touch event actually received
        }
        canvas.onmousedown = null;
        canvas.onmouseup = null;
        canvas.onmousemove = null;
        canvas.onmouseout = null;
    }

    function cleanUp() {
        $window.off('resize', resize);
        ignoreEvents();
    }

    ctx = canvas.getContext('2d');

    butRedo.click(function () {
        me.clear();
    });

    butCancel.click(function () {
        div.hide();
        cleanUp();
        me.clear();
        if (me.callback)
            me.callback(null);
    });

    butOK.click(function () {
        // only accept OK if at least one point was received
        if (strokes.length < 1)
            return;
        // hide everything and callback if requested
        div.hide();
        cleanUp();
        if (me.callback)
            me.callback(strokes);
    });

}
